<template>
  <div v-show="show" id="wallpaperlines">
    <div
      v-for="(n, index) in getLines"
      :key="index"
      class="lines"
      :style="getLeft(getLines, n)"
    ></div>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useImageEditorStore, ["getPOIEVariables", "getFormat"]),
    format: function () {
      return this.getFormat;
    },
    getLines: function () {
      var lines = this.getNumberOfLines() - 1;
      var result = lines > 0 ? lines : 0;
      this.changeSplit(result);
      return result;
    },
    show: function () {
      return this.getPOIEVariables.splitOiePdf;
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, ["changeSplit"]),
    getNumberOfLines: function () {
      var format = this.format;
      this.maxStep = 70;
      this.minStep = 50;
      if (format.width > 100) {
        var max = Math.floor(format.width / this.maxStep);
        var min = Math.ceil(format.width / this.minStep);
        return Math.floor((max + min) / 2);
      }
      return 0;
    },
    getLeft: function (total, n) {
      total = total + 1;
      return {
        left: (100 / total) * n + "%"
      };
    }
  }
};
</script>
